import syncService from '../services/SyncService';
import realtimeService from '../services/RealtimeService';

// Business data that is scoped to the signed-in user / workspace and must NOT
// leak to the next account on a shared device.
// NOTE: 'maidly_settings' (company info/logo) is intentionally NOT wiped here —
// it is an object that the array-based cloud sync does not back up, so clearing
// it would permanently destroy the company profile. It is low-sensitivity and
// gets overwritten when the next user loads their own settings.
const SYNCED_DATA_KEYS = [
  'maidly_customers', 'maidly_invoices', 'maidly_quotes', 'maidly_appointments',
  'maidly_timeEntries', 'maidly_employees', 'maidly_mileageEntries', 'maidly_expenses',
  'maidly_inventory', 'maidly_signatures', 'maidly_quoteTemplates',
  'maidly_invoiceTemplates', 'maidly_recurring_invoices', 'maidly_crews',
];

// Session / identity keys shared across the two auth contexts.
const SESSION_KEYS = [
  'maidly_auth_user', 'maidly_current_user', 'maidly_last_activity',
  'maidly_workspace_id', 'maidly_sync_queue', 'maidly_pending_2fa',
];

/**
 * Fully tear down the local session on logout so switching accounts on the
 * same browser can't (a) sync the new user into the old user's workspace or
 * (b) expose the old user's cached business data. Device-level keys
 * (device id, folder config, prefs) are intentionally preserved.
 */
export function clearLocalSession() {
  try {
    realtimeService.disconnect();
  } catch { /* socket may already be closed */ }
  try {
    syncService.setWorkspaceId(null);
  } catch { /* no-op */ }

  [...SESSION_KEYS, ...SYNCED_DATA_KEYS].forEach((k) => {
    try { localStorage.removeItem(k); } catch { /* ignore */ }
  });
}

export default clearLocalSession;
